module.exports = __webpack_public_path__ + "3500b5c52cc7b2409cb3edb842231021.svg";